import { DeliveryTimeType } from '@/features/orders/constants/delivery-time'
import {
    Asap,
    Timed,
} from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import dayjs from 'dayjs'
import { TFunction } from 'i18next'

export const formatDay = (day: string, t: TFunction<'app'>): string => {
    const today = dayjs().startOf('day')

    const dayObj = dayjs(day)

    const diff = dayObj.diff(today, 'day')

    if (diff === 0) return t('dayLabels.today')
    if (diff === 1) return t('dayLabels.tomorrow')

    return dayObj.format('DD.MM.')
}

const format = 'HH:mm'

export const formatAsapTime = (time: Asap, t: TFunction<'app'>): string => {
    return t('order.deliveryTime.asap', {
        time: dayjs().add(time.duration, 'minutes').format(format),
    })
}

export const formatTimedTime = (time: Timed): string => {
    const formattedEnd = dayjs(time.end).format(format)

    if (time.type === DeliveryTimeType.Exact) return formattedEnd

    const formattedStart = dayjs(time.start).format(format)

    return formattedStart + '–' + formattedEnd
}
